/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import {
  TableDefault,
  ShadowTableHead,
  StickyMainHeader,
  StickyShadowMainHeader,
  StickySubHeader,
  ArrowHolderSummary,
  ColumnContainerSummary,
  TeamAverageRow,
  ShadowSummaryColumn,
  ArrowDownContainer,
  ShadowTableColumn,
} from './styles';
import {Utils} from '../../utils/api';
import {GoChevronDown, GoChevronUp, GoArrowDown} from 'react-icons/go';
import {capitalizeFirstLetters} from '../../utils/hooks/text-formatter';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import HideOn from '../../assets/icons/HideOn.png';
import HideOff from '../../assets/icons/HideOff.png';
import Loader from '../loader/loader';

export default ({
  dataTableContent,
  dataAverage,
  dataCy,
  fatigueZone,
  setTableUpdated,
  hideExam,
}: {
  dataTableContent: Array<any>;
  dataAverage: any;
  dataCy?: string;
  fatigueZone?: boolean;
  setTableUpdated?: any;
  hideExam?: any;
}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const [loading, useLoading] = useState<boolean>(false);
  const UTILS = new Utils();

  useEffect(() => {
    useTable(dataTableContent);
    useLoading(false);
  }, [dataTableContent]);

  useEffect(() => {
    if (loading) {
      setTableUpdated(true);
    }
  }, [loading]);

  function changeTable(e) {
    useTable([...e]);
  }
  function toggleSortDate(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortIsoDate(params, sortOptions);
  }

  function toggleSortString(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }
  function toggleSortNumber(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }
  function changeStatus(change) {
    // Downward arrows hidden per requirements - logic preserved
    // if (change < 0) {
    //   return (
    //     <ArrowDownContainer>
    //       <GoArrowDown size="10px" color="#fff" />
    //     </ArrowDownContainer>
    //   );
    // }
    return null;
  }

  function SortingTableHead({title = '', attr, location, sortFunction}) {
    return (
      <StickySubHeader onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </StickySubHeader>
    );
  }
  function SortingShadowTableHead({title = '', attr, location, sortFunction}) {
    return (
      <ShadowTableHead onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </ShadowTableHead>
    );
  }

  function DownloadReport() {}

  return (
    <TableDefault data-cy={dataCy} minWidth="1200px">
      <thead>
        <tr>
          <StickyMainHeader colSpan={1}>HIDE</StickyMainHeader>
          <StickyMainHeader colSpan={1}>DATE</StickyMainHeader>
          <StickyMainHeader colSpan={3}>EVENT</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>TOTAL ARC</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>INTERNAL ROTATION</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>EXTERNAL ROTATION</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>FLEXION</StickyMainHeader>
        </tr>
        <tr>
          <StickySubHeader />
          <SortingTableHead title="Sort date" attr="date" location={['date']} sortFunction={toggleSortDate} />
          <SortingTableHead title="Type" attr="type" location={['event', 'type']} sortFunction={toggleSortString} />
          <SortingTableHead title="Pitches" attr="pitches" location={['event', 'pitches']} sortFunction={toggleSortString} />
          <SortingTableHead title="RPE" attr="rpe" location={['event', 'rpe']} sortFunction={toggleSortString} />
          <SortingShadowTableHead title="% Fresh" attr="tcurrent" location={['rom', 'freshTArcRatio']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead
            title="Change (°)"
            attr="tchange"
            location={['rom', 'freshTArcChange']}
            sortFunction={toggleSortNumber}
          />
          <SortingTableHead title="% Fresh" attr="ircurrent" location={['rom', 'freshIRRatio']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Change (°)" attr="irchange" location={['rom', 'freshIRChange']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead title="% Fresh" attr="ercurrent" location={['rom', 'freshERRatio']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead
            title="Change (°)"
            attr="erchange"
            location={['rom', 'freshERChange']}
            sortFunction={toggleSortNumber}
          />
          <SortingTableHead title="% Fresh" attr="scurrent" location={['rom', 'freshFlexionRatio']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Change (°)" attr="schange" location={['rom', 'freshFlexionChange']} sortFunction={toggleSortNumber} />
        </tr>
      </thead>
      <tbody onClick={() => useSort('')}>
        {table.length > 0 && (
          <TeamAverageRow>
            <td>Avg</td>
            <td>{loading && <Loader width="20px" color="#B1D6FF" />}</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage.freshTArcRatio, {digits: 0})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              {numberColumnFormatter(dataAverage.freshTArcChange, {digits: 0})}
              {changeStatus(dataAverage.freshTArcChange)}
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(dataAverage.freshIRRatio, {digits: 0})}</td>
            <td>
              {numberColumnFormatter(dataAverage.freshIRChange, {digits: 0})}
              {changeStatus(dataAverage.freshIRChange)}
            </td>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage.freshERRatio, {digits: 0})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              {numberColumnFormatter(dataAverage.freshERChange, {digits: 0})}
              {changeStatus(dataAverage.freshERChange)}
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(dataAverage.freshFlexionRatio, {digits: 0})}</td>
            <td>{numberColumnFormatter(dataAverage.freshFlexionChange, {digits: 0})}</td>
          </TeamAverageRow>
        )}
        {table.length > 0 ? (
          table.map((item, index) => {
            return (
              <TableItem
                key={item.postExamId}
                item={item}
                useLoading={useLoading}
                fatigueZone={fatigueZone}
                changeStatus={changeStatus}
                DownloadReport={DownloadReport}
                hideExam={hideExam}
              />
            );
          })
        ) : (
          <tr>
            <td colSpan={25}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableDefault>
  );
};

const TableItem = ({item, useLoading, fatigueZone, changeStatus, DownloadReport, hideExam}) => {
  const [hide, setHide] = useState<Boolean>(item.excludeFromExamAvg);
  const [opacity, setOpacity] = useState<string>(item.excludeFromExamAvg ? '0.5' : '1');

  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    hide ? setOpacity('0.5') : setOpacity('1');
    hideExam(item.postExamId, hide, 'post');
    useLoading(true);
  }, [hide]);

  function handleDate(date) {
    return date ? new Date(date).toLocaleDateString('en-US') : '-';
  }

  return (
    <tr style={{opacity: opacity}}>
      <td className="white pointer" onClick={() => setHide(!hide)}>
        {hide ? <img src={HideOn} alt="hideOn" /> : <img src={HideOff} alt="hideOn" />}
      </td>
      <td className="white">{handleDate(item?.date)}</td>
      <td className="white">{capitalizeFirstLetters(item?.event?.type, '_')}</td>
      <td className="white">
        {item?.event?.type === 'velo_day' ? item?.event?.highIntentsThrows : numberColumnFormatter(item?.event?.pitches, {digits: 0})}
      </td>
      <td className="white">{item?.event?.rpe || '-'}</td>
      <ShadowTableColumn>{numberColumnFormatter(item?.rom?.freshTArcRatio, {digits: 0})}</ShadowTableColumn>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.rom?.freshTArcChange, {digits: 0})}
        {changeStatus(item?.rom?.freshTArcChange)}
      </ShadowTableColumn>
      <td className="white">{numberColumnFormatter(item?.rom?.freshIRRatio, {digits: 0})}</td>
      <td className="white">
        {numberColumnFormatter(item?.rom?.freshIRChange, {digits: 0})}
        {changeStatus(item?.rom?.freshIRChange)}
      </td>
      <ShadowTableColumn>{numberColumnFormatter(item?.rom?.freshERRatio, {digits: 0})}</ShadowTableColumn>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.rom?.freshERChange, {digits: 0})}
        {changeStatus(item?.rom?.freshERChange)}
      </ShadowTableColumn>
      <td className="white">{item?.rom?.freshFlexionRatio || item?.rom?.flexionDegrees || '-'}</td>
      <td className="white">{item?.rom?.freshFlexionChange || '-'}</td>
    </tr>
  );
};
